import React from 'react';

import { injectIntl } from 'react-intl';

import messages from './messages'; // adjust path to your messages file
import styles from './OrderSummary.module.scss';

const OrderSummary = ({ product, orderSummary, intl }) => (
    <div className={styles.orderSummary}>
        <h5>{intl.formatMessage(messages.orderSummaryText)}</h5>
        <div className={styles.summaryRow}>
            <span>{intl.formatMessage(messages.membershipText, { name: product?.name })}</span>
            <span>${orderSummary.price}</span>
        </div>
        {orderSummary?.promo && (
            <div className={styles.summaryRow}>
                <span>Promo</span>
                <span>(${orderSummary.promo})</span>
            </div>
        )}
        <div className={styles.summaryRow}>
            <span>{intl.formatMessage(messages.taxesText)}</span>
            <span>${orderSummary.taxes}</span>
        </div>
        <div className={styles.summaryRow}>
            <strong>{intl.formatMessage(messages.totalText)}</strong>
            <strong>${orderSummary.total}</strong>
        </div>
    </div>
);

export default injectIntl(OrderSummary);